import { useCallback } from "react";

/**
 * Hook to scroll form fields to the center of the viewport or modal
 * Automatically detects if we're in a modal and scrolls the modal content instead
 */
export const useScrollToField = () => {
  const scrollToField = useCallback((fieldName: string, delay: number = 100) => {
    setTimeout(() => {
      const field =
        document.querySelector(`[name="${fieldName}"]`) || (document.querySelector(`#${fieldName}`) as HTMLElement);
      if (field) {
        // Check if we're in a react-modal (CommonModal uses ReactModal.Modal)
        const modalOverlay = document.querySelector(".ReactModal__Content");

        if (modalOverlay) {
          // We're in a modal - the overlay is the scrollable container
          const fieldRect = field.getBoundingClientRect();
          const overlayRect = modalOverlay.getBoundingClientRect();
          const overlayHeight = overlayRect.height;
          // Calculate current scroll position of the overlay
          const currentScrollTop = modalOverlay.scrollTop;
          // Calculate field position relative to overlay
          const fieldTopRelativeToOverlay = fieldRect.top - overlayRect.top + currentScrollTop;
          // Calculate target scroll position to center the field
          const targetScrollTop = fieldTopRelativeToOverlay - overlayHeight / 2 + fieldRect.height / 2;

          (modalOverlay as HTMLElement).scrollTo({
            top: Math.max(0, targetScrollTop),
            behavior: "smooth",
          });
        } else {
          // No modal - scroll the window
          const rect = field.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const targetY = window.scrollY + rect.top - viewportHeight / 2 + rect.height / 2;

          window.scrollTo({
            top: Math.max(0, targetY),
            behavior: "smooth",
          });
        }
      }
    }, delay);
  }, []);

  return { scrollToField };
};
